import { AmberHoc, AmberHocProps } from '../../../util';
import {
  DeleteBinStoragePeriodMutationVariables as Variables,
  // BinStoragePeriodFragmentFragment as Result,
  // GetGrainBinStoragePeriodQuery,
  // GetGrainBinStoragePeriodQueryVariables,
  // GetGrainBinStoragePeriodDocument,
  withDeleteBinStoragePeriod as HOC,
} from '../__generated';
import { GraphQLErrors } from './error';

type Result = {
  grain_bin_storage_cycle_id: number;
  grain_bin_id: number;
};

export type WithDeleteBinStoragePeriodHocChildProps = {
  /// TODO: update return type
  deleteBinStoragePeriod: (variables: Variables) => any;
};
export const withDeleteBinStoragePeriodHoc: AmberHoc<
  {},
  WithDeleteBinStoragePeriodHocChildProps
> = (component) =>
  HOC<
    AmberHocProps<{}, WithDeleteBinStoragePeriodHocChildProps, typeof component>,
    WithDeleteBinStoragePeriodHocChildProps
  >({
    options: { errorPolicy: 'all' },
    props: (props) => {
      const { mutate } = props;
      return {
        deleteBinStoragePeriod: async (variables) => {
          if (!mutate) {
            throw new Error('Unexpected UI error');
          }
          const result = await mutate({
            variables,
            update: (proxy, { data, errors }) => {
              if (errors || !data) {
                return;
              }
              const { deleteBinStoragePeriod: result } = data;
              if (!result) {
                return;
              }
              console.log('Successfully mutated data with results: ', result);
              // proxy.writeQuery<GetGrainBinStoragePeriodQuery, GetGrainBinStoragePeriodQueryVariables>({
              //   query: GetGrainBinStoragePeriodDocument,
              //   data: { __typename: 'Query', latest_grain_bin_events: result },
              //   variables: { grain_bin_id: variables.grain_bin_id },
              // });
            },
          });
          if (!result) {
            throw new Error('Unexpected server response');
          }
          const { errors, data } = result;
          if (errors) {
            throw new GraphQLErrors(errors);
          }
          if (!data) {
            throw new Error('Unexpected server response');
          }
          return data.deleteBinStoragePeriod || [];
        },
      };
    },
  })(component as any);
